import * as i0 from '@angular/core';
import { Directive, Input, EventEmitter, ViewContainerRef, Component, ViewChild, ContentChild, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class NgxRerenderDirective {
    templateRef;
    viewContainer;
    constructor(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    set mcRerender(_val) {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.3", type: NgxRerenderDirective, selector: "[mcRerender]", inputs: { mcRerender: "mcRerender" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[mcRerender]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }], propDecorators: { mcRerender: [{
                type: Input
            }] } });

class NgxRerenderContentDirective {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderContentDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.3", type: NgxRerenderContentDirective, selector: "[mcRerenderContent]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[mcRerenderContent]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

class NgxRerenderComponent {
    outletRef;
    content;
    trigger;
    triggerChange = new EventEmitter();
    ngOnChanges(changes) {
        if (!changes.trigger || changes.trigger.currentValue === undefined) {
            return;
        }
        const triggerValue = changes.trigger.currentValue;
        if (!this.outletRef) {
            /**
             * Even if the initial outlet is not yet ready on the first onChange
             * we still ne to reset the boolean binding,
             * otherwise the next change to true will not properly be tracked
             */
            if (typeof triggerValue === 'boolean') {
                this.setBooleanBindingToFalse();
            }
            return;
        }
        if (typeof triggerValue !== 'boolean') {
            this.rerender();
            return;
        }
        if (triggerValue) {
            this.rerender();
            this.setBooleanBindingToFalse();
        }
    }
    rerender() {
        if (!this.outletRef) {
            return;
        }
        this.outletRef.clear();
        this.outletRef.createEmbeddedView(this.content.templateRef);
    }
    setBooleanBindingToFalse() {
        setTimeout(() => this.triggerChange.emit(false));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.3", type: NgxRerenderComponent, selector: "mc-rerender", inputs: { trigger: "trigger" }, outputs: { triggerChange: "triggerChange" }, queries: [{ propertyName: "content", first: true, predicate: NgxRerenderContentDirective, descendants: true }], viewQueries: [{ propertyName: "outletRef", first: true, predicate: ["outlet"], descendants: true, read: ViewContainerRef }], usesOnChanges: true, ngImport: i0, template: `
    <ng-container [ngTemplateOutlet]="content.templateRef" #outlet></ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'mc-rerender',
                    template: `
    <ng-container [ngTemplateOutlet]="content.templateRef" #outlet></ng-container>
  `,
                }]
        }], propDecorators: { outletRef: [{
                type: ViewChild,
                args: ['outlet', { read: ViewContainerRef }]
            }], content: [{
                type: ContentChild,
                args: [NgxRerenderContentDirective]
            }], trigger: [{
                type: Input
            }], triggerChange: [{
                type: Output
            }] } });

class NgxRerenderModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderModule, declarations: [NgxRerenderComponent,
            NgxRerenderDirective,
            NgxRerenderContentDirective], imports: [CommonModule], exports: [NgxRerenderComponent,
            NgxRerenderDirective,
            NgxRerenderContentDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.3", ngImport: i0, type: NgxRerenderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxRerenderComponent,
                        NgxRerenderDirective,
                        NgxRerenderContentDirective,
                    ],
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        NgxRerenderComponent,
                        NgxRerenderDirective,
                        NgxRerenderContentDirective,
                    ],
                }]
        }] });

/*
 * Public API Surface of ngx-rerender
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxRerenderComponent, NgxRerenderContentDirective, NgxRerenderDirective, NgxRerenderModule };
